import { render, staticRenderFns } from "./SampleMemoryNoise.vue?vue&type=template&id=4e65272f&scoped=true"
import script from "./SampleMemoryNoise.vue?vue&type=script&lang=js"
export * from "./SampleMemoryNoise.vue?vue&type=script&lang=js"
import style0 from "./SampleMemoryNoise.vue?vue&type=style&index=0&id=4e65272f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e65272f",
  null
  
)

export default component.exports